<template>
  <div class="coupon_wrap">
    <div class="coupon_title">
      <span>券营销成本</span>
      <el-button size="mini"  @click="toImg('oilChart', '券营销成本', taskChildData.taskName)" :disabled="piePic.length === 0">下载图片</el-button>
    </div>
    <div class="coupon_people">总计发券<span>{{otherData.totalCouponCnt | isNullOr0}}</span>张，共计<span>{{otherData.totalCouponAmount | isNullOr0}}</span>元，券营销成本<span>{{otherData.totalCostAmount | isNullOr0}}</span>元</div>
    <div class="coupon_time">统计时间：{{taskChildData.startTimeFormat || '-'}}至{{taskChildData.endTimeFormat || '-'}}<span v-if="taskChildData.status === 4">(持续更新中)</span></div>
    <template  v-if="piePic.length > 0">
      <div class="coupon_change">
        <el-radio-group v-model="type" style="margin-bottom: 10px;" @change="handelChange">
          <el-radio-button label="1">券金额</el-radio-button>
          <el-radio-button label="2">券张数</el-radio-button>
        </el-radio-group>
      </div>
      <div class="coupon_pic" id="coupon_pic">
        <pie :id="'oilChart'" :data="piePic" :type="type"/>
      </div>
    </template>
    <template class="coupon_pic" v-else>
      <noDataPic/>
    </template>
  </div>
</template>
<script>
import noDataPic from './noDataPic'
import pie from './counponCostPic'
import mixinDown from './mixin'
export default {
  props:{
    couponCostData: {
      type: Object
    },
    taskChildData: {
      type: Object
    }
  },
  mixins: [mixinDown],
  components: {
    pie,
    noDataPic
  },
  data () {
    return {
      type: '1',
      piePic: [],
      otherData: {},
      amountData: [],
      couData: []
    }
  },
  watch: {
    couponCostData: {
      handler (newValue) {
        this.piePic = []
        this.amountData = []
        this.couData = []
        const { totalCouponAmount, totalCouponCnt, totalCostAmount, taskStartTime, taskEndTime, couponList} = newValue
        this.otherData = { totalCouponAmount, totalCouponCnt, totalCostAmount, taskStartTime, taskEndTime }
        couponList && couponList.forEach(item => {
          this.amountData.push({ value: item.couponAmount, name: item.couponTypeName, couCnt: item.couponCnt})
          this.couData.push({ value: item.couponCnt, name: item.couponTypeName, amount: item.couponAmount })
        })
        this.piePic = this.amountData
        this.type = '1'
      },
      immediate: true
    }
  },
  methods: {
    handelChange (val) {
      this.type = val
      if (val === '1') {
        this.piePic = this.amountData
      } else {
        this.piePic = this.couData
      }
    }
  }
}
</script>
<style scoped lang="less">
.coupon_wrap{
  padding: 16px;
}
.coupon_title{
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  >span{
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
  }
  .coupon_btn{
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #C0C4CC;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
}
.coupon_people{
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  >span{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3377FF ;
  }
}
.coupon_time{
  margin-top: 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}
.coupon_change{
  margin-top: 20px;
}
/deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #3377FF;
  background-color: #fff;
  border-color: #409EFF;
  box-shadow: -1px 0 0 0 #409eff;
}
.coupon_pic{
  padding: 0 0 10px 0;
  margin-top: 10px;
}
</style>